import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const BasicInput = props => {
  const {
    inputType = 'text',
    name,
    label,
    required,
    placeholder,
    content,
    controlFunc,
    labelStyles,
    isValid,
    touchFunc,
    min,
    max,
    inputStyles,
    disabled = false,
    autoComplete = '',
  } = props;

  const isRequired = required
    ? 'basic-input__label-text basic-input__label-text--required'
    : 'basic-input__label-text';

  const inputClassNames = isValid
    ? 'basic-input'
    : 'basic-input basic-input--invalid';

  return (
    <div className="basic-input__wrapper">
      {label && (
        <label
          className="basic-input__label"
          style={labelStyles}
          htmlFor={name}
        >
          <span className={isRequired}>{label}</span>
        </label>
      )}

      <input
        className={inputClassNames}
        style={inputStyles}
        name={name}
        type={inputType}
        value={content}
        onChange={controlFunc}
        onBlur={touchFunc}
        placeholder={placeholder}
        min={min}
        max={max}
        disabled={disabled}
        autoComplete={autoComplete}
      />
    </div>
  );
};

BasicInput.propTypes = {
  inputType: PropTypes.oneOf(['text', 'number', 'email', 'password', 'tel']),
  label: PropTypes.string,
  labelStyle: PropTypes.string,
  name: PropTypes.string,
  controlFunc: PropTypes.func.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  isValid: PropTypes.bool,
  touchFunc: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
};

export default BasicInput;
